import { formatMessage } from "devextreme/localization";

import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import CustomerListDto from "../classes/dtos/accountmodule/CustomerListDto";
import CustomerInfosDto from "../classes/dtos/accountmodule/CustomerInfosDto";
import CustomerWithWorkspacesDto from "../classes/dtos/accountmodule/CustomerWithWorkspacesDto";
import WorkspaceDto from "../classes/dtos/workspacemodule/WorkspaceDto";

const CustomerApi = {

    GetCustomerListAsync: async function (): Promise<ProcessingResult<CustomerListDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Customer/GetCustomers", {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.customers.map((e: { id: number; name: string; role: number; status: number; isCurrent: boolean; }) => new CustomerListDto(e.id, e.name, e.role, e.status, e.isCurrent)));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());

    },

    GetCustomerListWithWorkspacesAsync: async function (): Promise<ProcessingResult<CustomerWithWorkspacesDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Customer/GetCustomersWithWorkspaces", {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.customers.map((e: { id: number; name: string; role: number; status: number; isCurrent: boolean; enterpriseMode: boolean; workspaces: { id: number; name: string; isCurrent: boolean; }[]; }) =>
                new CustomerWithWorkspacesDto(e.id, e.name, e.role, e.status, e.isCurrent, e.enterpriseMode, e.workspaces.map((w) => new WorkspaceDto(w.id, w.name || formatMessage("Workspace_DefaultName"), w.isCurrent)))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());

    },

    SwitchCustomerAsync: async function (targetCustomerId: number, targetWorkspaceId: number | null = null): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Customer/SwitchCustomer", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({ 'targetCustomerId': targetCustomerId, 'targetWorkspaceId': targetWorkspaceId })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    InviteUserAsync: async function (email: string, roleGroupId: number): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Customer/InviteUser", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({ 'email': email, 'roleGroupId': roleGroupId })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.status);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetCustomerInfosAsync: async function (): Promise<ProcessingResult<CustomerInfosDto>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Customer/GetCustomerInfos", {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CustomerInfosDto(data.customer.name, data.customer.customerFragment));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());

    },

    UpdateCustomerInfosAsync: async function (customerInfosDto: CustomerInfosDto): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Customer/UpdateCustomerInfos", {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({ 'customerInfos': { 'name': customerInfosDto.Name, 'customerFragment': customerInfosDto.CustomerFragment } })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default CustomerApi;